export default __webpack_public_path__ + "static/stacked-area-5a7dc7fbf44217e41ba3aafe6e22f3e4.png";